// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2-DzK","form":"styles_form__2VlVW"};